module.exports = __webpack_public_path__ + "img/headline03.fc06c9d3.jpg";